import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import CodifyDefinitionsEditor from "./CodifyDefinitionsEditor";

const CodifyDefinitionsEditorPage = () => {
  const { codifyDefinitionId } = useParams();
  const navigate = useNavigate();
  const [codifyDefinition, setCodifyDefinition] = useState(null);
  const [loading, setLoading] = useState(true);

  const isNew = codifyDefinitionId === "new";

  const createEmptyCodifyDefinition = () => ({
    _id: crypto.randomUUID(),
    collection: "default",
    type: "",
    description: "",
    rolePrompt: "You are a London (Re)insurance Market Reform Contract data codifier.",
    instructionPrompt: "Your task is to transform London Market Reform Contract statements into structured data.",
    formatPrompt: "Respond using only the following format:",
    generalPrompt: "When interpreting please follow these general directions:",
    generalDirection: "",
    fieldPrompt: "For the following fields in the data use the following directions:",
    fieldDirection: "",
    codeFieldPrompt: "For the following fields in the data use only the following code values as described:",
    codeFieldDirection: "",
    finalPrompt: "Now codify the following input into the matching data format:",
    dataDefinitions: [],
    createdDate: new Date().toISOString(),
  });

  useEffect(() => {
    const fetchCodifyDefinition = async () => {
      if (isNew) {
        setCodifyDefinition(createEmptyCodifyDefinition());
        setLoading(false);
      } else {
        try {
          const res = await fetch(`https://codify.poc.mrc.ai/api/definitions/${codifyDefinitionId}`);
          const data = await res.json();
          setCodifyDefinition(data);
        } catch (error) {
          console.error("Error fetching codify definition:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchCodifyDefinition();
  }, [codifyDefinitionId, isNew]);

  const handleSave = async (updatedCodifyDefinition) => {
  try {
    const method = isNew ? "POST" : "PUT";
    const url = isNew
      ? `https://codify.poc.mrc.ai/api/definitions`
      : `https://codify.poc.mrc.ai/api/definitions/${codifyDefinitionId}`;

    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedCodifyDefinition),
    });

    if (!res.ok) throw new Error("Failed to save codify definition");

    const saved = await res.json();
    setCodifyDefinition(saved);
  } catch (err) {
    console.error("Error saving codify definition:", err);
  }
};

  const handleClose = () => navigate("/");

  if (loading) return <Spinner />;

  return <CodifyDefinitionsEditor codifyDefinition={codifyDefinition} onClose={handleClose} isNew={isNew} />;
};

export default CodifyDefinitionsEditorPage;
